import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';

@Injectable()
export class SessionViewCalendarService {
    constructor(private http: HttpClient) {}

    findByDates(startDate: string): Observable<any[]> {
        const endDate = moment(startDate).add(5, 'day').format('YYYY-MM-DD');
        return this.http
            .get<any[]>(
                '/api/training-sessions?from=' +
                    startDate +
                    '&to=' +
                    endDate +
                    '&calendarView=true',
                {}
            )
            .pipe(map((agencies) => this.transformResponse(agencies)));
    }

    private transformResponse(agencies: any[]) {
        agencies = agencies.sort(this.locationSort.bind(this));

        agencies.forEach((agency) => {
            agency.internals = agency.internals
                .map((room) => this.assignAgencyName(room, agency))
                .sort(this.sortByNameWithNullIdLast.bind(this));

            agency.externals = agency.externals.sort(
                this.sortByNameWithNullIdLast.bind(this)
            );
        });

        return agencies;
    }

    private sortByNameWithNullIdLast(itemA, itemB) {
        return this.getNameOrMaxStringIfNull(itemA).localeCompare(
            this.getNameOrMaxStringIfNull(itemB)
        );
    }

    private getNameOrMaxStringIfNull(item) {
        if (!item.id) {
            return 'ZZZZZZZZZZZZZZZZ';
        }
        return item.name;
    }

    private locationSort(locationA: any, locationB: any) {
        return (
            this.maxNumberIfNull(locationA.id) -
            this.maxNumberIfNull(locationB.id)
        );
    }

    private maxNumberIfNull(i) {
        if (i == null) {
            return Number.MAX_SAFE_INTEGER;
        }
        return i;
    }

    private assignAgencyName(room, agency) {
        room.agencyName = agency.name;
        return room;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/session/view/calendar/calendar.service.ts